import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UserMaster_Create, UserMaster_Create_External, UserMaster_Delete, UserMaster_GetUserDetailsByDocNo, UserMaster_ReadAll, UserMaster_ReadByBusinessId, UserMaster_ReadByHospitalId, UserMaster_ReadById, UserMaster_ReadBySocietyId, UserMaster_SuggestUserName, UserMaster_Update, UserMaster_ValidateUniqueIdentities } from "src/app/GlobalVariable";
import { UserMasterCreateRequestDTO, UserMasterDeleteRequestDTO, UserMasterDTO, UserMasterGetUserDetailsByDocNo, UserMasterList, UserMasterReadByBusinessId, UserMasterReadByHospitalId, UserMasterReadBySocietyId, UserMasterReadyByUserId, UserMasterSuggestUserNameRequestDTO, UserMasterSuggestUserNameResponse, UserMasterUpdateRequestDTO, UserMasterValidateUniqueIdentitiesRequestDTO, UserMasterValidateUniqueIdentitiesResponseDTO } from "./users.interface";

@Injectable({
    providedIn: 'root'
})

export class UsersService {
   
    private http = inject(HttpClient);

    UserMaster_Create(data: UserMasterCreateRequestDTO): Observable<UserMasterDTO> {
        return this.http.post<UserMasterDTO>(UserMaster_Create, data);
    }

    UserMaster_Create_External(
      data: UserMasterCreateRequestDTO,
      xApiKey: string,
      xApiTimestamp: string,
      xApiNonce: string,
      xApiSignature: string
    ): Observable<UserMasterDTO> {
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Api-Key': xApiKey,
        'X-Api-Timestamp': xApiTimestamp,
        'X-Api-Nonce': xApiNonce,
        'X-Api-Signature': xApiSignature
      });
      return this.http.post<UserMasterDTO>(UserMaster_Create_External, data, { headers });
    }

    UserMaster_Update(data: UserMasterUpdateRequestDTO): Observable<UserMasterDTO> {
        return this.http.post<UserMasterDTO>(UserMaster_Update, data);
    }

    UserMaster_ReadAll(): Observable<UserMasterList> {
        return this.http.get<UserMasterList>(UserMaster_ReadAll);
    }

    UserMaster_Delete(data: UserMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(UserMaster_Delete, data);
    }

    UserMaster_ReadByUserId(data: UserMasterReadyByUserId): Observable<UserMasterDTO> {
        return this.http.post<UserMasterDTO>(UserMaster_ReadById, data);
    }

    UserMaster_ReadByBusinessId(data: UserMasterReadByBusinessId): Observable<UserMasterList> {
        return this.http.post<UserMasterList>(UserMaster_ReadByBusinessId, data);
    }

    UserMaster_ReadByHospitalId(data: UserMasterReadByHospitalId): Observable<UserMasterList> {
        return this.http.post<UserMasterList>(UserMaster_ReadByHospitalId, data);
    }

    UserMaster_GetUserDetailsByDocNo(data: UserMasterGetUserDetailsByDocNo): Observable<UserMasterDTO> {
        return this.http.post<UserMasterDTO>(UserMaster_GetUserDetailsByDocNo, data);
    }

    UserMaster_ReadBySocietyId(data: UserMasterReadBySocietyId): Observable<UserMasterList> {
        return this.http.post<UserMasterList>(UserMaster_ReadBySocietyId, data);
    }

    UserMaster_SuggestUserName(data: UserMasterSuggestUserNameRequestDTO): Observable<UserMasterSuggestUserNameResponse> {
        return this.http.post<UserMasterSuggestUserNameResponse>(UserMaster_SuggestUserName, data);
    }


    UserMaster_ValidateUniqueIdentities(data: UserMasterValidateUniqueIdentitiesRequestDTO): Observable<UserMasterValidateUniqueIdentitiesResponseDTO> {
        return this.http.post<UserMasterValidateUniqueIdentitiesResponseDTO>(UserMaster_ValidateUniqueIdentities, data);
    }
}